document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-toggle-password]");
  if (!btn) return;

  const fieldset = btn.closest(".password-wrapper");
  const input = fieldset?.querySelector("input.password-field");
  if (!input) return;

  const isPassword = input.type === "password";
  input.type = isPassword ? "text" : "password";
  btn.classList.toggle("is-active", isPassword);
});

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide.bind(this);
    });

    this.querySelector('#modal-overlay').addEventListener('click', this.hide.bind(this));

  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    // this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.classList.add('open');
    if (popup) popup.loadContent();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.classList.remove('open');
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class TFSwiper extends HTMLElement {
  constructor() {
    super();
    this.el = null;
    this._swiper = null;
    this._mounted = false;
    this._timer = null;
    this._observer = null;
    this._resizeObserver = null;
    this._lastSignature = "";
    this._isBooting = false;
    this._retryCount = 0;
    this._maxRetry = 20;

    this._onResize = this._onResize.bind(this);
    this._onEditorEvent = this._onEditorEvent.bind(this);
    this._onBlockSelect = this._onBlockSelect.bind(this);
  }

  connectedCallback() {
    if (this._mounted) return;
    this._mounted = true;

    this._bindElements();
    this._watch();
    this._boot(true);

    window.addEventListener("resize", this._onResize, { passive: true });
    document.addEventListener("shopify:section:load", this._onEditorEvent);
    document.addEventListener("shopify:section:reorder", this._onEditorEvent);
    document.addEventListener("shopify:section:select", this._onEditorEvent);
    document.addEventListener("shopify:block:select", this._onBlockSelect);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._onResize);
    document.removeEventListener("shopify:section:load", this._onEditorEvent);
    document.removeEventListener("shopify:section:reorder", this._onEditorEvent);
    document.removeEventListener("shopify:section:select", this._onEditorEvent);
    document.removeEventListener("shopify:block:select", this._onBlockSelect);

    this._clearTimer();

    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }

    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }

    this._destroy();
    this._mounted = false;
  }

  _bindElements() {
    this.el = this.querySelector(".swiper.tf-swiper");
  }

  _clearTimer() {
    if (this._timer) clearTimeout(this._timer);
    this._timer = null;
  }

  _destroy() {
    const sw = this.el?.swiper || this._swiper;
    if (sw) {
      try {
        sw.destroy(true, true);
      } catch (e) {}
    }
    this._swiper = null;
  }

  _onResize() {
    this._scheduleBoot(false, 80);
  }

  _onEditorEvent(e) {
    if (!e?.target) return;
    if (!e.target.contains(this) && !this.contains(e.target)) return;
    this._scheduleBoot(true, 80);
  }

  _onBlockSelect(e) {
    if (!e?.target) return;
    if (!e.target.contains(this) && !this.contains(e.target)) return;

    this._scheduleBoot(false, 50);

    setTimeout(() => {
      this._slideToSelectedBlock(e.target);
    }, 120);
  }

  _slideToSelectedBlock(target) {
    this._bindElements();
    if (!this.el) return;

    const swiper = this.el.swiper || this._swiper;
    if (!swiper) return;

    const slide = target.closest(".swiper-slide");
    if (!slide || !this.el.contains(slide)) return;

    const realIndexAttr = slide.getAttribute("data-swiper-slide-index");
    const realIndex = realIndexAttr !== null ? parseInt(realIndexAttr, 10) : -1;

    if (swiper.params.loop && realIndex >= 0 && typeof swiper.slideToLoop === "function") {
      try {
        swiper.slideToLoop(realIndex, 300, false);
        this._hardUpdate(swiper);
        return;
      } catch (e) {}
    }

    const slides = Array.from(swiper.slides || []);
    let index = slides.indexOf(slide);

    if (index < 0) {
      const domSlides = Array.from(this.el.querySelectorAll(".swiper-slide"));
      index = domSlides.indexOf(slide);
    }

    if (index >= 0) {
      try {
        swiper.slideTo(index, 300, false);
      } catch (e) {}
      this._hardUpdate(swiper);
    }
  }

  _watch() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }

    const wrapper = this.querySelector(".swiper-wrapper");
    if (wrapper) {
      this._observer = new MutationObserver((mutations) => {
        let shouldReinit = false;

        for (const mutation of mutations) {
          if (mutation.type === "childList") {
            shouldReinit = true;
            break;
          }
        }

        if (shouldReinit) {
          this._scheduleBoot(true, 80);
        }
      });

      this._observer.observe(wrapper, {
        childList: true
      });
    }

    if (window.ResizeObserver) {
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }

      this._resizeObserver = new ResizeObserver(() => {
        this._scheduleBoot(false, 80);
      });

      this._resizeObserver.observe(this);
    }
  }

  _scheduleBoot(force = false, delay = 60) {
    this._clearTimer();
    this._timer = setTimeout(() => this._boot(force), delay);
  }

  num(v, fallback) {
    const n = parseFloat(String(v));
    return Number.isFinite(n) ? n : fallback;
  }

  _readConfig() {
    const d = this.el?.dataset || {};

    const desktop = this.num(d.preview, 1);
    const tablet = this.num(d.tablet, 1);
    const mobile = this.num(d.mobile, 1);
    const mobileSm = d.mobileSm !== undefined ? this.num(d.mobileSm, mobile) : mobile;

    const spaceLg = this.num(d.spaceLg, 0);
    const spaceMd = this.num(d.spaceMd, 0);
    const space = this.num(d.space, 0);

    const perGroup = this.num(d.pagination, 1);
    const perGroupMd = this.num(d.paginationMd, 1);
    const perGroupLg = this.num(d.paginationLg, 1);

    const gridRows = this.num(d.grid, 1);
    const effect = d.effect || "slide";
    const autoplayEnabled = d.auto === "true" || d.auto === "1";
    const speed = this.num(d.speed, 800);
    const delay = this.num(d.delay, 3000);
    const loop = d.loop === "true" || d.loop === "1";
    const direction = d.direction || "horizontal";

    const paginationEl =
      this.querySelector(".tf-sw-pagination") ||
      this.el?.querySelector(".tf-sw-pagination");

    const nextEl =
      this.querySelector(".nav-next-swiper") ||
      this.el?.querySelector(".nav-next-swiper");

    const prevEl =
      this.querySelector(".nav-prev-swiper") ||
      this.el?.querySelector(".nav-prev-swiper");

    const opts = {
      direction,
      speed,
      effect,
      loop,
      observer: false,
      observeParents: false,
      watchOverflow: true,
      slidesPerView: mobile,
      slidesPerGroup: perGroup,
      spaceBetween: space,
      grid: gridRows > 1 ? { rows: gridRows, fill: "row" } : undefined,
      autoplay: autoplayEnabled
        ? { delay, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      breakpoints: {
        480: {
          slidesPerView: mobileSm,
          slidesPerGroup: perGroup,
          spaceBetween: space
        },
        768: {
          slidesPerView: tablet,
          slidesPerGroup: perGroupMd,
          spaceBetween: spaceMd
        },
        1200: {
          slidesPerView: desktop,
          slidesPerGroup: perGroupLg,
          spaceBetween: spaceLg
        }
      }
    };

    if (effect === "fade") {
      opts.fadeEffect = { crossFade: true };
    }

    if (paginationEl) {
      opts.pagination = {
        el: paginationEl,
        clickable: true
      };
    }

    if (nextEl && prevEl) {
      opts.navigation = {
        nextEl,
        prevEl
      };
    }

    return opts;
  }

  _getSignature() {
    if (!this.el) return "";

    const d = this.el.dataset || {};

    return JSON.stringify({
      preview: d.preview,
      tablet: d.tablet,
      mobile: d.mobile,
      mobileSm: d.mobileSm,
      spaceLg: d.spaceLg,
      spaceMd: d.spaceMd,
      space: d.space,
      pagination: d.pagination,
      paginationMd: d.paginationMd,
      paginationLg: d.paginationLg,
      grid: d.grid,
      effect: d.effect,
      auto: d.auto,
      speed: d.speed,
      delay: d.delay,
      loop: d.loop,
      direction: d.direction
    });
  }

  _boot(force = false) {
    if (this._isBooting) return;
    this._isBooting = true;

    this._bindElements();

    if (!this.el || !window.Swiper) {
      this._isBooting = false;
      if (this._retryCount < this._maxRetry) {
        this._retryCount += 1;
        this._scheduleBoot(force, 120);
      }
      return;
    }

    const width = this.el.offsetWidth || this.offsetWidth || 0;
    if (width === 0) {
      this._isBooting = false;
      if (this._retryCount < this._maxRetry) {
        this._retryCount += 1;
        this._scheduleBoot(force, 120);
      }
      return;
    }

    this._retryCount = 0;

    const newSignature = this._getSignature();
    const existingSwiper = this.el.swiper || this._swiper;
    const needInit = !existingSwiper;
    const needReinit = force || newSignature !== this._lastSignature;

    if (needInit || needReinit) {
      this._destroy();

      const opts = this._readConfig();
      this._swiper = new window.Swiper(this.el, opts);
      this._lastSignature = newSignature;

      this._afterInit();
      this._isBooting = false;
      return;
    }

    this._hardUpdate(existingSwiper);
    this._isBooting = false;
  }

  _afterInit() {
    const sw = this.el.swiper || this._swiper;
    if (!sw) return;

    this._hardUpdate(sw);

    requestAnimationFrame(() => this._hardUpdate(sw));
    setTimeout(() => this._hardUpdate(sw), 100);
    setTimeout(() => this._hardUpdate(sw), 300);
  }

  _hardUpdate(sw) {
    if (!sw) return;

    try { sw.updateSize(); } catch (e) {}
    try { sw.updateSlides(); } catch (e) {}
    try { sw.updateProgress(); } catch (e) {}
    try { sw.updateSlidesClasses(); } catch (e) {}
    try { sw.pagination?.render?.(); } catch (e) {}
    try { sw.pagination?.update?.(); } catch (e) {}
    try { sw.navigation?.update?.(); } catch (e) {}
    try { sw.update(); } catch (e) {}
  }
}

if (!customElements.get("tf-swiper")) {
  customElements.define("tf-swiper", TFSwiper);
}
